if (!customElements.get("product-form")) {
  console.log("product-form init");
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            var checkbox = document.getElementById("mycheckbox-yes");
            var tempChosen = {};

            if (checkbox != null && checkbox.checked) {
              tempChosen.parentProduct =
                document.getElementById("product_title").value;
              tempChosen.parentID = document.getElementById("product_id").value;
              tempChosen.stringTypeSelected = document
                .getElementById("stringTypeSelected")
                .getAttribute("data-selected-value");
              tempChosen.stringBrandSelected = document
                .getElementById("string-brand")
                .getAttribute("data-selected-value");
              tempChosen.stringSelected =
                document.getElementById("stringSelected").innerHTML;
              tempChosen.mains = document
                .getElementById("string-mains-btn")
                .getAttribute("data-selected-value");
              tempChosen.crosses = document
                .getElementById("string-crosses-btn")
                .getAttribute("data-selected-value");
              tempChosen.quantity = formData.get("quantity");
              tempChosen.stringSelected = tempChosen.stringSelected.substring(
                0,
                tempChosen.stringSelected.indexOf(" -")
              ); // cut price from string
              tempChosen.stringChoiceid = document
                .getElementById("stringSelected")
                .getAttribute("data-selected-value");
              tempChosen.labourID = document.getElementById("labour_id").value;

              this.updateCartAttributes(tempChosen);
              let relatedProducts = document.getElementsByClassName(
                "cart-drawer-related-product"
              );

              // Loop through the selected elements and hide them
              for (var i = 0; i < relatedProducts.length; i++) {
                relatedProducts[i].style.display = "none";
              }
            }

            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }
      updateCartAttributes(data) {
        var productID = data.stringChoiceid;
        var labourID = data.labourID;
        var parentID = data.parentID;
        var racquetName = data.parentProduct;
        var quant = data.quantity;

        console.log("quant", data);

        var mains = data.mains;
        var crosses = data.crosses;
        if (productID == "" || mains == "" || crosses == "") {
          return;
        }
        var string = "Default";
        if ((data.stringTypeSelected = "hybrid")) {
          string =
            data.stringSelected +
            " (Mains: " +
            $("#hybridMainsSelected").data("selected-value") +
            ")";
        } else {
          string = data.stringSelected;
        }

        let props = {
          Racquet: racquetName,
          String: string,
          Tension: "Mains: " + mains + ", Crosses: " + crosses,
          _racquetID: parentID,
        };

        let json = {
          items: [
            {
              quantity: quant,
              id: labourID,
              properties: props,
            },
            {
              quantity: quant,
              id: productID,
            },
          ],
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(json),
        })
          .then((response) => response.json())
          .then((response) => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: productID,
              cartData: response,
            });
            this.error = false;
            this.updateCartQuantity();
            this.cart.renderContents(response);
            this.cart.getSectionsToRender().map((section) => section.id);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }

      updateCartQuantity() {
        fetch(window.Shopify.routes.root + "cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((response) => {
            const parentElement = document.querySelector(".cart-count-bubble");
            const childElement = parentElement.querySelector(
              '[aria-hidden="true"]'
            );
            if (childElement) {
              childElement.textContent = response.item_count;
              const headings = document.querySelectorAll(".drawer__heading");
              ///console.log(newText,'newTextnewText');
              headings.forEach((heading) => {
                heading.textContent =
                  "My Cart (" + response.item_count + " Items)";
              });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
